import React from 'react';
import DesktopRedirectPage from '../DesktopRedirectPage';

function DesktopSignInRedirectPage() {
    return <DesktopRedirectPage />;
}

export default DesktopSignInRedirectPage;
